import { Exchange } from "@cmctechnology/webinvest-constants";

export enum MarketMovement {
  MarketUp = 'market-up',
  MarketDown = 'market-down'
}

export enum MarketStatus {
  Closed = 'Closed',
  Open = 'Open',
  PreOpen = 'Pre Open',
  Suspended = 'Suspended',
  TradingHalt = 'Trading Halt'
}

export interface IAsxMarketStatusProps {
  TimeStamp: string;
  // TODO: Verify values with backend
  MarketStatus?: MarketStatus;
  AsxStatus: string;
  Description: string;
  // TODO: Verify values with backend
  Css?: 'open' | 'closed' | 'close';
  PollingInterval: number;
}

export interface IIndexSummary {
  Code: string;
  Index: string;
  Value: string;
  Move: string;
  MovePercent: string;
  CssClass: 'market-up' | 'market-down';
  QuoteTimeUi: string;
  LastUpdateAt: string;
}

export interface IIndicesSummaryGet1 {
  Indices: IIndexSummary[];
}

interface IMarketStatusGet1 {
  MarketStatus?: MarketStatus;
  ExchangeTimeStamp: string;
  Description: string;
}

export type IMarketSummaryResponse = [IMarketStatusGet1, IIndicesSummaryGet1];

export interface IMarketSummary {
  status: MarketStatus;
  open: boolean;
  code: string;
  index: string;
  value: string;
  move: string;
  movePercent: string;
  quoteTime?: string;
  up: boolean;
  exchange: Exchange;
  exchangeTimestamp: string;
}
